import { LifeInsuranceProductSubType } from 'even-ts-static'
import * as React from 'react'

const Exclamation = require('assets/components/exclamation.svg')
const styles = require('./styles')

interface Props {
  totalAdbOffers: number
  totalTermLifeOffers: number
  selectedTab: string
}

export const AdbBanner: React.FC<Props> = ({ totalAdbOffers, totalTermLifeOffers, selectedTab }) =>
  selectedTab === LifeInsuranceProductSubType.AccidentalDeathBenefits && !totalTermLifeOffers && totalAdbOffers > 0 ? (
    <div className={styles.messagePillContainer}>
      <Exclamation />
      <p>You were matched with quotes from LeapLife for accidental death benefit insurance because of your health</p>
    </div>
  ) : null
